import req from '../../api/request'
import { ENDPOINTS } from '../../api/endpoints'

/**
 * Fetches the full competition hierarchy in one call. The raw payload is
 * handed to `buildOperationsTree`, which owns the shape mapping.
 */
export const getScheduleTree = async (scheduleId: string): Promise<unknown> => {
  const { data } = await req(ENDPOINTS.SCHEDULES.GET_TREE(scheduleId))
  return data
}
